import { onMounted } from 'vue'
import {
  getEnterpriseConfigByDomain,
  getEnterpriseFileByDomain
} from '@/api/personalization'
import { applyFavicon } from '@/composables/useSystemBrandApply'

/**
 * 未登录登录页：按当前域名读取租户配置的系统图标并应用。
 * 租户端登录页、客户端登录页共用，避免只在其中一个页面生效。
 */
export function usePublicTenantFavicon() {
  const applyTenantFavicon = async (fileId: string) => {
    try {
      const dataUrl = await getEnterpriseFileByDomain(window.location.hostname, fileId)
      if (dataUrl) {
        applyFavicon(dataUrl)
      }
    } catch (error) {
      console.warn('[CT_PUBLIC_BRAND] 获取企业系统图标失败，使用默认图标', error)
    }
  }

  onMounted(async () => {
    try {
      const config = await getEnterpriseConfigByDomain(window.location.hostname)
      if (config?.systemIconFile) {
        void applyTenantFavicon(config.systemIconFile)
      }
    } catch (error) {
      console.warn('[CT_PUBLIC_BRAND] 获取企业配置失败，使用默认图标', error)
    }
  })
}
